const Actions = {
    fetch_taxonomies: 'fetchTaxonomies',
    refresh_auth_user: 'refreshAuthUser',
    fetch_vehicle_years: 'fetchVehicleYears',
    fetch_vehicle_makes: 'fetchVehicleMakes',
    fetch_vehicle_models: 'fetchVehicleModels',
    fetch_vehicle_trims: 'fetchVehicleTrims',
};

export default Actions
